export default __webpack_public_path__ + "static/media/2-1-2.ea8bc679.jpg";